export const groupType = {
  OnlineOrder: "OnlineOrder",
  MemberWeb: "MemberWeb",
};

const onlineOrderButtonTypes = [
  {
    value: 1,
    name: "Profolio",
    text: "個人資料",
    type: groupType.OnlineOrder,
  },
  {
    value: 2,
    name: "HistoryOrder",
    text: "歷史訂單",
    type: groupType.OnlineOrder,
  },
  {
    value: 3,
    name: "TrackOrder",
    text: "追蹤訂單",
    type: groupType.OnlineOrder,
  },
  {
    value: 4,
    name: "OrderNow",
    text: "立刻點餐",
    type: groupType.OnlineOrder,
  },
];

const memberWebButtonTypes = [
  {
    value: 5,
    name: "MemberWeb",
    text: "會員網站",
    type: groupType.MemberWeb,
  },
  {
    value: 6,
    name: "Point",
    text: "點數",
    type: groupType.MemberWeb,
  },
];

export function getOnlineOrderButtonTypes() {
  return onlineOrderButtonTypes;
}

export function getMemberWebButtonTypes() {
  return memberWebButtonTypes;
}

export function getAll() {
  return [...onlineOrderButtonTypes, ...memberWebButtonTypes];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}

export function getByType(type) {
  // Member 為既有收銀台 LINE 官方帳號設定使用的舊類型名稱。
  const normalizedType = type == "Member" ? groupType.MemberWeb : type;
  const types = getAll().filter(function (item) {
    return item.type == normalizedType;
  });
  return types;
}
